import {
  HousePriceTypeEnum,
  HousesInformationsFieldsFragment,
} from '../../../../lib/graphql'

export const isIndividualHouse = (house: HousesInformationsFieldsFragment) => {
  return house.priceType === HousePriceTypeEnum.INDIVIDUAL
}
